import { withStyles } from '@mui/styles';
import React from 'react';
import AbstractDialogTab from '../../base/dialog/components/web/AbstractDialogTab';
import { translate } from '../../base/i18n/functions';
import Checkbox from '../../base/ui/components/web/Checkbox';
import Slider from '../../base/ui/components/web/Slider';
import { inklusivaSettingsStyles } from '../ui-constants';
const styles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        headline: {
            marginBottom: theme.spacing(3),
            fontSize: '0.875rem'
        },
        inputElement: {
            marginBottom: theme.spacing(1),
            fontWeight: 'bold'
        },
        textareaElement: {
            marginBottom: theme.spacing(1),
            fontSize: '1rem',
            width: '100%'
        },
        description: {
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing(2),
            fontSize: '0.875rem',
            fontWeight: 'normal'
        },
        ...inklusivaSettingsStyles(theme)
    };
};
class DistressBtnTab extends AbstractDialogTab {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { classes, active, dimming, volume, message, messageText, t } = this.props;
        return (React.createElement("div", { className: classes.container },
            React.createElement("h2", null, t('settings.distressbtn.btn_engage_headline')),
            React.createElement("p", { className: 'mt-05' }, t('settings.distressbtn.intro')),
            React.createElement("h3", null, t('settings.distressbtn.btn_engage_headline')),
            React.createElement(Checkbox, { checked: active, className: classes.inputElement, label: t('settings.distressbtn.btn_engage_label'), name: 'distressbtn_enable', onChange: () => super._onChange({
                    active: !active
                }) }),
            React.createElement("p", { className: 'mt-05' }, t('settings.distressbtn.btn_engage_desc')),
            React.createElement("h3", null, t('settings.distressbtn.sliders_headline')),
            React.createElement("div", { className: classes.controlContainer },
                React.createElement("div", { className: classes.controlColumn },
                    React.createElement(Slider, { id: 'dimming-slider', className: classes.inputElement, defaultValue: dimming, label: t('settings.distressbtn.dimlights_label'), max: 100, min: 0, onChange: event => super._onChange({
                            dimming: event.target.value
                        }), step: 1 })),
                React.createElement("div", { className: classes.valueColumn },
                    dimming,
                    "%")),
            React.createElement("div", { className: classes.controlContainer },
                React.createElement("div", { className: classes.controlColumn },
                    React.createElement(Slider, { id: 'volume-slider', className: classes.inputElement, defaultValue: volume, label: t('settings.distressbtn.setvolume_label'), max: 100, min: 0, onChange: event => super._onChange({
                            volume: event.target.value
                        }), step: 1 })),
                React.createElement("div", { className: classes.valueColumn },
                    volume,
                    "%")),
            React.createElement("div", { className: classes.inputblockContainer },
                React.createElement("div", { className: 'mt-15' },
                    React.createElement(Checkbox, { checked: message, className: classes.inputElement, label: t('settings.distressbtn.messagebtn_enable_label'), name: 'messagebtn_enable', onChange: () => super._onChange({
                            message: !message
                        }) })),
                React.createElement("p", { className: 'mt-05' }, t('settings.distressbtn.messagebtn_enable_desc')),
                React.createElement("textarea", { "aria-label": 'Notfallnachricht', className: classes.textareaElement, defaultValue: messageText, id: 'distress_message', onChange: event => super._onChange({
                        messageText: event.target.value
                    }), placeholder: t('settings.distressbtn.message_placeholder'), rows: 3 }))));
    }
}
export default withStyles(styles)(translate(DistressBtnTab));
